import { BaseModel } from './base-model';

export class OrganizationType extends BaseModel {

  // for CASL subject detection on code minification
  static get modelName() { return 'OrganizationType'; }

  name: string;
}
